import { ActionType } from '../infrastructure/actionTypes';
import { IOrderStatus } from '../infrastructure/interfaces';

export interface IOptionsState {
  statuses: IOrderStatus[];
}

const loadingInitialState: IOptionsState = {
  statuses: [],
};

export default (state = loadingInitialState, action: any) => {
  switch (action.type) {
    case ActionType.GET_ORDER_STATUSES_DONE:
      {
        return { statuses: action.statuses };
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options.ts